import {
  GET_ALL_CLIENTS,
  SET_CLIENT,
  GET_SELECTED_CLIENT,
  LOADING_CLIENT,
  GET_CLIENT,
  GET_ACCURACY,
  ERROR_CLIENT,
  ADD_CLIENT,
  UPDATE_CLIENT,
  DELETE_CLIENT,
  LOADING_SUBORDINATES,
  SUBORDINATES,
  ERROR_SUBORDINATES
} from "store/actions/clientAction";

export default (state = {}, action) => {
  switch (action.type) {
    case LOADING_CLIENT:
      return {
        ...state,
        isLoadingClient: action.payload
      };
    case ERROR_CLIENT:
      return {
        ...state,
        errorClient: action.payload
      };
    case SET_CLIENT:
      return {
        ...state,
        selectedClient: action.payload
      };
    case GET_SELECTED_CLIENT:
      return {
        ...state,
        selectedClient: action.payload
      };
    case GET_ALL_CLIENTS:
      return {
        ...state,
        getAllClients: action.payload
      };
    case GET_CLIENT:
      return {
        ...state,
        getClient: action.payload
      };
    case GET_ACCURACY:
      return {
        ...state,
        getAccuracy: action.payload
      };
    case ADD_CLIENT:
      return {
        ...state,
        addClient: action.payload
      };
    case UPDATE_CLIENT:
      return {
        ...state,
        updateClient: action.payload
      };
    case DELETE_CLIENT:
      return {
        ...state,
        deleteClientStatus: action.payload
      };

    // Subordinates
    case LOADING_SUBORDINATES:
      return {
        ...state,
        loadingSubordinates: action.payload
      };
    case SUBORDINATES:
      return {
        ...state,
        subordinates: action.payload
      };
    case ERROR_SUBORDINATES:
      return {
        ...state,
        errorSubordinates: action.payload
      };

    default:
      return state;
  }
};
